import { render, staticRenderFns } from "./PageWineAdForm.vue?vue&type=template&id=51035576"
import script from "./PageWineAdForm.vue?vue&type=script&lang=ts"
export * from "./PageWineAdForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports